export enum SubnavAction {
  ABOUT = "ACTION_ABOUT",
  ALL_TOPICS = "ACTION_ALL_TOPICS",
  BOOKMARKS = "ACTION_BOOKMARKS",
  COACHMARK_SETTINGS = "ACTION_COACHMARK_SETTINGS",
  CREATE = "ACTION_CREATE",
  CUSTOM_MAPS = "ACTION_CUSTOM_MAPS",
  EMBED_MAPS_IN_YOUR_SITE = "ACTION_EMBED_MAPS_IN_YOUR_SITE",
  FEEDBACK = "ACTION_FEEDBACK",
  FULLSCREEN = "ACTION_FULLSCREEN",
  HOME = "HOME",
  LANGUAGE = "ACTION_LANGUAGE",
  MODERATE = "ACTION_MODERATE",
  SOURCES = "ACTION_SOURCES",
  MONITOR = "ACTION_MONITOR",
  RESOURCES = "ACTION_RESOURCES",
  TERMS = "ACTION_TERMS",
  THEME = "ACTION_THEME",
  WHATS_NEW = "ACTION_WHATS_NEW",
}
